// O casamento responde por dois dominios com formatos de URL diferentes:
//   brunoelauana.com.br    -> rotas na raiz      (/confirmar-presenca)
//   lauanarezendeadv.com.br -> rotas sob prefixo (/casamento/confirmar-presenca)
// Este modulo e a unica fonte dessa diferenca.

const HOST_CASAMENTO = 'brunoelauana.com.br';

export const ehDominioCasamento =
    typeof window !== 'undefined' &&
    window.location.hostname.replace(/^www\./, '') === HOST_CASAMENTO;

// rota() -> '/' ou '/casamento'
// rota('presentes') -> '/presentes' ou '/casamento/presentes'
export function rota(sub = '') {
  const base = ehDominioCasamento ? '' : '/casamento';
  return sub ? `${base}/${sub}` : (base || '/');
}

// Rotas do casamento na raiz, so quando estamos no dominio proprio.
// Ficam ANTES das demais no router para vencerem a rota '/' do app principal.
// Depois do casamento (out/2026) so o mural continua no ar; o resto do dominio
// cai nele. Import fixo, nao por template: um import(`.../${x}.vue`) faria o
// webpack empacotar todas as paginas da pasta, inclusive as aposentadas.
export function rotasNaRaiz() {
  if (!ehDominioCasamento) return [];

  return [
    {path: '/', redirect: '/mural'},
    {path: '/mural', component: () => import('@/components/casamento/Mural.vue'), meta: {requiresAuth: false}},
  ];
}
